<app-lector-manual-ru *ngIf="language === 'ru'"></app-lector-manual-ru>
<app-lector-manual-en *ngIf="language === 'en'"></app-lector-manual-en>
